import { createApiClient, type ApiClient } from '@argzombie/api-client';
import { useMemo, type ReactNode } from 'react';
import { ApiContext, apiBaseUrl } from './api';
import { Session } from './session';

/**
 * Provides the typed API client, authenticated with the admin session (refreshing once on a 401). Authorization is
 * enforced by the API.
 */
export function ApiProvider({
  children,
  baseUrl = apiBaseUrl,
  client,
  session,
}: {
  children: ReactNode;
  baseUrl?: string;
  client?: ApiClient;
  session?: Session;
}) {
  const value = useMemo(() => {
    const s = session ?? new Session(baseUrl);
    return {
      client: client ?? createApiClient(baseUrl, s.accessToken, { fetch: s.fetch }),
      baseUrl,
      session: s,
    };
  }, [client, baseUrl, session]);
  return <ApiContext.Provider value={value}>{children}</ApiContext.Provider>;
}
